<template>
  <slot></slot>
  <modal :id="modalId" :title="approveTitleC + ' Invoice'">
    <form :id="formId" :action="action" method="POST">

      <div class="text-center">
        <p>
          Are you sure you want to {{ approveTitle }} invoice ID {{ id }}?
        </p>
      </div>

      <input type="hidden" name="_method" value="PATCH">
      <input type="hidden" name="_token" :value="$csrf_token">
    </form>

    <template #footer>
      <button type="button" class="btn btn-default" @click="hideModal"><i class="fa fa-fw fa-close"></i> Cancel</button>
      <button type="submit" :class="buttonClass" :form="formId">
        <i :class="iconClass"></i>
        {{ approveTitleC }} Invoice
      </button>
    </template>

  </modal>
</template>

<script>
import HasModal from "./../mixins/HasModal";
export default {

  /**
   *
   * Confirmation dialog to claim invoice approval.
   *
   * Input properties:
   *
   * modalId - custom id for modal component.
   * action  - form action URL.
   * title   - form title.
   *
   * Usage examples:
   *
   * <approve-invoice-modal modal-id="approveInvoiceModal" title="Approve Invoice">
   *   <a class="btn btn-sm btn-success" v-modal="'approveInvoiceModal'">
   *     <i class="fa fa-check-circle-o"></i> Approve
   *   </a>
   * </approve-invoice-modal>
   *
   */

  mixins: [HasModal],

  props: {

    // Modal dialog id.
    modalId: {
      required: false,
      type: String,
      default: 'approveInvoiceModal'
    },

    // Form action URL.
    action: {
      type: String,
      default: ""
    },

    // Invoice ID for deletion.
    id: {
      type: String,
      default: ""
    },

    // Required action: true for approve or false for unapprove.
    approve: {
      type: Boolean,
      required: true
    },

  },

  /**
   * Computed values
   */
  computed: {

    formId() {
      return this.modalId + "-form"
    },

    approveTitle() {
      return this.approve ? 'approve' : 'unapprove';
    },

    approveTitleC() {
      return this.approve ? 'Approve' : 'Unapprove';
    },

    buttonClass() {
      return this.approve ? 'btn btn-success' : 'btn btn-warning';
    },

    iconClass() {
      return this.approve ? 'fa fa-check-circle-o' : 'fa fa-times-circle-o';
    },

  },
}
</script>
